export default function(liveChatClass) {
    console.log('Creating live chat card elements');
    const liveChatCardOuterContainer = document.createElement('div');
    liveChatCardOuterContainer.classList.add('live-chat-card__outer');
    if (liveChatClass.quickAnimation) {
        liveChatCardOuterContainer.classList.add('live-chat-card__outer--quick-animation');
    }

    const bgElement = document.createElement('div');
    bgElement.classList.add('live-chat-card__bg');

    liveChatCardOuterContainer.appendChild(bgElement);

    const liveChatCardContainer = document.createElement('div');
    liveChatCardContainer.classList.add('live-chat-card');

    const closeButtonContainer = document.createElement('div');
    closeButtonContainer.classList.add('live-chat-card__close');
    closeButtonContainer.innerHTML = `<svg viewBox="0 0 10 10" width="10" height="10" fill="none" style="display: block;"><path class="close-cross__path" stroke="#ffffff" stroke-linecap="square" d="M1.36364 1.36364L8.63636 8.63636"></path><path class="close-cross__path" stroke="#ffffff" stroke-linecap="square" d="M8.63636 1.36364L1.36364 8.63636"></path></svg>`;

    // const xmlns = "http://www.w3.org/2000/svg";

    // const closeButton = document.createElementNS(xmlns, "svg");
    // closeButton.setAttributeNS(null, "viewBox", "0 0 10 10");
    // closeButton.setAttributeNS(null, "width", 10);
    // closeButton.setAttributeNS(null, "height", 10);
    // closeButton.setAttributeNS(null, "fill", "none");
    // closeButton.style.display = "block";

    // const path1 = document.createElementNS(xmlns, "path");
    // path1.setAttributeNS(null, 'class', "close-cross__path");
    // path1.setAttributeNS(null, 'stroke', "#ffffff");
    // path1.setAttributeNS(null, 'stroke-linecap', "square");
    // path1.setAttributeNS(null, 'd', "M1.36364 1.36364L8.63636 8.63636");
    // closeButton.appendChild(path1);

    // const path2 = document.createElementNS(xmlns, "path");
    // path2.setAttributeNS(null, 'class', "close-cross__path");
    // path2.setAttributeNS(null, 'stroke', "#ffffff");
    // path2.setAttributeNS(null, 'stroke-linecap', "square");
    // path2.setAttributeNS(null, 'd', "M8.63636 1.36364L1.36364 8.63636");
    // closeButton.appendChild(path2);

    // closeButtonContainer.appendChild(closeButton);

    closeButtonContainer.addEventListener('click', function() {
        liveChatClass.removeCard();
        dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'Live Chat',
            'eventAction': 'Close button',
            'eventLabel': 'Closed',
            'eventValue': 0,
        });
    });
    liveChatCardContainer.appendChild(closeButtonContainer);

    const contentContainer = document.createElement('div');
    contentContainer.classList.add('live-chat-card__content-container');
    liveChatCardContainer.appendChild(contentContainer);
    liveChatCardOuterContainer.appendChild(liveChatCardContainer);

    document.body.appendChild(liveChatCardOuterContainer);

    return {
        card: liveChatCardContainer,
        content: contentContainer,
        // closeButton: closeButton,
    };
}